export enum EApiKey {
  GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN',
  GET_USER_PROFILE = 'GET_USER_PROFILE',
  GET_ENTITY_IMAGE = 'GET_ENTITY_IMAGE',
  GET_ENTITY_MULTIPLE_IMAGES = 'GET_ENTITY_MULTIPLE_IMAGES',
  GET_MULTIPLE_ENTITIES_MULTIPLE_IMAGES = 'GET_MULTIPLE_ENTITIES_MULTIPLE_IMAGES',
  GET_USER_AVATAR = 'GET_USER_AVATAR',
  GET_NEWS_FEED = 'GET_NEWS_FEED',
}

export enum UserRole {
  Admin = 1,
  Breeder = 2,
}

export enum DocumentTypeCode {
  Avatar = 1,
  Banner = 2,
  Logo = 3,
  Document = 4,
  Image = 5,
}

export enum DocumentImageSize {
  'thumb' = 'thumb',
  'xs' = 'xs',
  's' = 's',
  'm' = 'm',
  'l' = 'l',
  'xl' = 'xl',
}

export const PUBLIC_SEARCH_PREFIX = '/publicSearch';
